// NAAMANE: werkt blokinhoud bij na een variantwissel (zelfde patroon als product-price.js).
if (!customElements.get('nm-live')) {
  class NmLive extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section, dialog');
      if (!this.scope || this.onSelect) return;
      this.onSelect = (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        Promise.resolve(event.promise)
          .then((result) => {
            const html = result && result.detail && result.detail.html;
            if (!html) return;
            const fresh = html.querySelector(`nm-live[data-block-id="${this.dataset.blockId}"]`);
            if (fresh) this.innerHTML = fresh.innerHTML;
          })
          .catch(() => {});
      };
      this.scope.addEventListener('shopify:product:select', this.onSelect);
    }
    disconnectedCallback() {
      if (this.scope && this.onSelect) this.scope.removeEventListener('shopify:product:select', this.onSelect);
      this.onSelect = null;
    }
  }
  customElements.define('nm-live', NmLive);
}
